import steps from '@/helpers/mixins/steps'
import ModalDialogs from 'vue-modal-dialogs'
import context from '@/providers/context'
import Tutorial from '@/helpers/components/interact/Tutorial'

function checkPrompt (user_id, title) {
  if (context.getters.prompt(title)) {
    return Promise.resolve(false);
  }
  return context.getters.api
    //get prompt ID
    .get('prompts?filter=title::eq::' + title + '&range=single')
    .then(prompt => {
        if (prompt.length) {
          if (!prompt.active) {
            throw new Error('Prompt "' + title + '" is not active.');
          }
          return prompt;
        } else {
          throw new Error('Prompt "' + title + '" does not exist.');
        }
      }
    )
    //check if user has already confirmed it
    .then(prompt => context.getters.api
      .get('prompts_confirmations' +
        '?filter=' +
          'prompts_id::eq::' + prompt.id +
          ',users_id::eq::' + user_id +
        '&range=single'
      )
      .then(confirmation => {
        //if already confirmed -> store to context and proceed
        if (confirmation.length) {
          context.commit('prompt', title);
          return false;
        } else {
          return prompt;
        }
      })
    )
  ;
}

function confirmPrompt (prompt, user_id, confirmed = true) {
  return context.getters.api
    .post('prompts_confirmations', {
      prompts_id: prompt.id,
      confirmed: Boolean(confirmed),
      users_id: user_id,
    })
    .then(() => context.commit('prompt', prompt.title))
  ;
}

/*
 * Applies guard to (sub)pages of section. Section can be e.g. "contestdream" or "contestdream.new". Title is the title of prompt
 * Guard is an optional function that returns promise, resolved as false if tutorial should not be shown (will be automatically confirmed as viewed) - should return a promise
 */
export function routerTutorialGuard(router, section, title, steps, guard) {

  if (typeof guard === 'undefined') {
    guard = () => Promise.resolve(true);
  }

  var tutorial_modal = ModalDialogs.makeDialog(Tutorial, 'pages');
  var force_tutorial = function (next) {
    return tutorial_modal(steps).then(() => next());
  };
  var section_sections = section.split('.').filter(s => s.length);
  router.beforeResolve((to, from, next) => {
    //unnamed route -> do not interfere
    if (!to.name) {
      return next();
    }
    //proceed normally if the requested page is not the tutorial target page/subpage
    var to_sections = to.name.split('.');
    for (let i in section_sections) {
      if (!to_sections[i] || to_sections[i] !== section_sections[i]) {
        return next();
      }
    }
    //proceed normally if user has already seen the tutorial
    if (context.getters.prompt(title)) {
      return next();
    }
    guard().then(showtutorial => {
      if (!showtutorial) {
        context.commit('prompt', title);
        return next();
      }
      return context.getters.async('user').then((user) => {
        //user not logged in - cannot check prompt state
        if (!user.length) {
          return next();
        } else if (user.length) {
          return checkPrompt(user.id, title)
            .then(prompt => {
              if (prompt) {
                return tutorial_modal(steps)
                  .then(confirmed => confirmPrompt(prompt, user.id, confirmed))
                ;
              }
            })
            .then(() => next())
          ;
        }
        //on any error just proceed normally
      }).catch(e => {
        console.log(e);
        return next();
      });
    })
  })
}

export var PromptInfo = {
  render (el) {
    if (this.content && !this.closed) {
      return el(this.element, {
        class: 'user-help',
      }, [
        el('div', {
          domProps: {
            innerHTML: this.content
          },
        }),
        this.dismissible ? el('em', {
          class: 'close',
          on: {
            click: this.dismiss,
          }
        }) : null
      ]);
    }
  },
  props: {
    dismissible: {default: true},
    title: {required: true},
    element: {default: 'div'},
  },
  data () {return {
    closed: false,
  }},
  computed: {
    content () {
      if (this.prompt) {
        return this.prompt.description;
      }
    },
  },
  asyncComputed: {
    prompt: {
      get () {
        return this.async('user')
          .then(user => checkPrompt(user.id, this.title))
        ;
      },
      watch () {
        this.reload;
      }
    },
  },
  methods: {
    dismiss (confirmed) {
      if (!this.prompt) {
        return;
      }
      confirmed = confirmed || false;
      this.closed = true;
      return this.async('user')
        .then(user => confirmPrompt(this.prompt, user.id, confirmed))
      ;
    },
  },
};

const tutorial = {
  mixins: [steps],
  data () {return {
    pageerrors: [],
  }},
};

export default tutorial;


// WEBPACK FOOTER //
// ./src/providers/tutorial.js